import React, { Suspense, useContext, useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { useForm, Controller } from 'react-hook-form';
import Select, { SingleValue } from 'react-select';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import axios from 'axios';
import { StripeCardElementChangeEvent } from '@stripe/stripe-js';

import DatePicker from 'react-datepicker';
import OTPInput from '../common/input/OTPInput/OTPInput';
import EmailInput from '../common/input/EmailInput/EmailInput';
import TextInput from '../common/input/TextInput/TextInput';
import Toast from '../toast/Toast';
import Popup from '../common/popup/Popup';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import PhoneInput, { CountryData } from 'react-phone-input-2';

import { ToastType } from '../debitCard/DebitCard';
import { getStripeIDVerificationSecret, getVerificationSession } from '../../redux/stripe/actions/stripe.action';
import { REGEX } from '../../constants/regex';
import { AppDispatch, IRootState } from '../../redux/rootReducer';
import {
    createUser,
    sendEmailVerificationRequest,
    sendPhoneVerificationRequest,
    uploadImages,
    verifyEmailOTP,
    verifyPhoneOTP,
} from '../../redux/auth/actions/auth.action';
import Loader from '../common/loader/Loader';
import drop from '../../images/icons/icon-drop-down.svg';
import Terms from '../auth/Terms';
import RadioInput from '../common/input/RadioInput/RadioInput';
import PasswordInput from '../common/input/PasswordInput/PasswordInput';
import { CustomizedState } from '../auth/interfaces/auth.interface';
import { useLocation, useNavigate } from 'react-router-dom';
import { getLocationById, getLocationPublicDetailsById, locationClickEvent } from '../../redux/location/actions/location.action';
import { AppContext } from '../context/AppContect';
import Timer from '../timer/Timer';
import StripeVerification from '../../images/stripe-verification.svg';
import { checkPhoneEmailExist } from '../../redux/verify-user/actions/verifyUser.action';
import { getLeadSource } from '../../redux/lead-sources/actions/leadSources.action';
import { getLocationList } from '../../redux/auth/actions/locations.action';

// import Popup from '../../common/popup/Popup';
import Webcam from 'react-webcam';
import CloseIcon from '../../images/icon-close.svg';
import CamLayer from '../../images/cam-layer.svg';

import styles from './SignUp.module.css';
import 'react-datepicker/dist/react-datepicker.css';
import { useCameraAccess } from '../../hooks/useCameraAccess';

type OptionType = {
    value: string;
    label: string;
};

const bed: OptionType[] = [
    { value: '0', label: 'Studio' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
];

type VerificationMethodType = null | 'Phone Number' | 'Email';

type LeadSourceOption = any;

type FormValues = {
    profileImage: File | null;
    firstName: string;
    lastName: string;
    email: string;
    expectedMoveInDate: string;
    DesiredBeds: string;
    emailVerified: boolean;
    phoneVerified: boolean;
    stripeVerification: boolean;
    stripeDocVerificationClientId: string;
    password: string;
    confirmPassword: string;
    stripeCustomerId: string;
    phoneNumber: string;
    pmsLeadSource: LeadSourceOption | null;
};

export const base64ToFile = (base64String: string, fileName: string, contentType: string): File => {
    const trimmedBase64String = base64String.trim();

    if (!trimmedBase64String.startsWith('data:image/jpeg;base64,')) {
        throw new Error('Invalid base64 string format');
    }
    const byteCharacters = atob(trimmedBase64String.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType });
    return new File([blob], fileName, { type: contentType });
};

const SignUp = () => {
    const stripe = useStripe();
    const elements = useElements();
    const [activeStep, setActiveStep] = useState(1);
    const [showVerifyEmailPopup, setShowVerifyEmailPopup] = useState(false);
    const [otp, setOtp] = useState<string[]>(Array(6).fill(''));
    const dispatch: AppDispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const appContext = useContext(AppContext);
    const [toastMessage, setToastMessage] = useState<string | null>(null);
    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState<ToastType>(null);
    const [webhookWaiting, setWebhookWaiting] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [isOpen, setIsTnCOpen] = useState(false);
    const [locationId, setLocationId] = useState<string | null>(null);
    const [unitId, setUnitId] = useState('');
    const location = useLocation();
    const state = location.state as CustomizedState;
    const { destinationURL, modifiedAppointment } = state || '';
    const [cardError, setCardError] = useState<string | null>(null);
    const [cardComplete, setCardComplete] = useState(false);
    const [expiryTimeStamp, setExpiryTimeStamp] = useState<Date | null>(null);
    const navigate = useNavigate();
    const [verificationMethod, setVerificationMethod] = useState<VerificationMethodType>(null);
    const { data: locationData } = useSelector((state: IRootState) => state.locationReducer.locationPublicDetails);
    const [showOTPInput, setShowOTPInput] = useState(false);
    const contactLink = useSelector((state: IRootState) => state.locationReducer.locationById.data?.location?.contactLink);
    const [leadSource, setLeadSource] = useState<LeadSourceOption[]>([]);
    const leadSourceData = useSelector((state: IRootState) => state.leadSourceReducer.data);
    const { data: locationListData, loading: locationListLoader } = useSelector((state: IRootState) => state?.locationListReducer);
    const [preview, setPreview] = useState<string | null>(null);
    const [showCustomModal, setShowCustomModal] = useState(false);
    const { isEnabled, isSupported, error, enableCamera, disableCamera } = useCameraAccess();
    const [showWebCam, setShowWebCam] = useState(false);
    const webcamRef = useRef<Webcam>(null);
    const [phoneNumberLength, setPhoneNumberLength] = useState(11);
    const [dialCode, setDialCode] = useState('1');

    useEffect(() => {
        if (locationId) {
            dispatch(getLeadSource(locationId));
        }
    }, [locationId]);

    useEffect(() => {
        setLeadSource(leadSourceData.leadSources);
    }, [leadSourceData]);

    const generateBedArray = (maxValue: number): OptionType[] => {
        const bed: OptionType[] = [{ value: 'Studio', label: 'Studio' }];
        for (let i = 1; i <= maxValue; i++) {
            bed.push({ value: i.toString(), label: i.toString() });
        }
        return bed;
    };

    const handleCardChange = (event: StripeCardElementChangeEvent) => {
        setCardComplete(event.complete);
        setCardError(event.error ? event.error.message : null);
    };

    const {
        handleSubmit,
        getValues,
        watch,
        setValue,
        trigger,
        setError,
        clearErrors,
        formState: { errors },
        control,
    } = useForm<FormValues>({
        defaultValues: {
            profileImage: null,
            firstName: '',
            lastName: '',
            email: '',
            expectedMoveInDate: '',
            DesiredBeds: '',
            emailVerified: false,
            phoneVerified: false,
            stripeVerification: false,
            stripeDocVerificationClientId: '',
            password: '',
            confirmPassword: '',
            stripeCustomerId: '',
            phoneNumber: '',
            pmsLeadSource: null,
        },
        mode: 'onChange',
    });

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
        if (activeStep === 1) {
            clearErrors('password');
            clearErrors('confirmPassword');
        }
    }, [activeStep]);

    const checkIsValid = () => {
        if (errors.DesiredBeds || errors.email || errors.phoneNumber || errors.expectedMoveInDate || errors.firstName || errors.lastName) {
            return false;
        } else {
            return true;
        }
    };

    const videoConstraints: MediaTrackConstraints | boolean = {
        facingMode: 'user', // or 'environment' for rear camera
    };

    const verifyStripeDocument = async (response: any) => {
        const verificationData = await getVerificationSession(response.id);

        setValue('stripeVerification', verificationData.status === 'verified' ? true : false);
        if (verificationData?.status === 'verified') {
            setValue('stripeDocVerificationClientId', verificationData?.last_verification_report);
            setIsLoading(false);
            setShowToast(true);
            setToastType('success');
            setToastMessage('Document verified Successfully');
        }
        if (verificationData.status === 'verified') {
            setIsLoading(false);
        } else if (verificationData?.status === 'processing') {
            setTimeout(() => {
                verifyStripeDocument(response);
            }, 10000);
        } else {
            setIsLoading(false);
            setShowToast(true);
            setToastType('error');
            setToastMessage('Document verification failed');
        }
    };

    useEffect(() => {
        var locationId = '';
        if (destinationURL && destinationURL !== '/' && !modifiedAppointment && destinationURL.includes('/location/')) {
            const [, splittedLocationUrl] = destinationURL.split('/location/');

            if (splittedLocationUrl.includes('/unit/')) {
                const [id, unitId] = splittedLocationUrl.split('/unit/');
                unitId && setUnitId(unitId);
                locationId = id;
            } else {
                locationId = splittedLocationUrl;
            }
            setLocationId(locationId);
        }

        locationId && dispatch(getLocationPublicDetailsById(locationId));
    }, [destinationURL, dispatch, modifiedAppointment]);

    useEffect(() => {
        if (locationId) {
            dispatch(locationClickEvent(locationId, 'marketingLinkBeforeLogin'));
        }
    }, [locationId]);

    useEffect(() => {
        dispatch(getLocationList());
        localStorage.clear();
    }, []);

    const verifyId = async () => {
        if (!stripe || getValues('stripeVerification')) {
            return;
        } else {
            setWebhookWaiting(true);
            setToastMessage('');

            const response = await getStripeIDVerificationSecret();

            if (stripe) {
                const data = await stripe.verifyIdentity(response?.client_secret);
                if (data.error) {
                    setWebhookWaiting(false);
                    return;
                } else {
                    setIsLoading(true);
                    verifyStripeDocument?.(response);
                }
                if (locationId) {
                    dispatch(locationClickEvent(locationId, 'stripeVerified'));
                }
                setWebhookWaiting(false);
            } else {
            }
        }
    };

    const onOTPVerificationSuccess = (message: string) => {
        setToastMessage(message);
        setToastType('success');
        setShowToast(true);
        setIsLoading(false);
        verificationMethod === 'Email' ? setValue('emailVerified', true) : setValue('phoneVerified', true);
        setShowVerifyEmailPopup(false);
        setExpiryTimeStamp(null);
        setOtp(Array(6).fill(''));
        setActiveStep(2);
    };

    const onOTPVerificationFailure = (message: string) => {
        setToastMessage(message);
        setToastType('error');
        setShowToast(true);
        setIsLoading(false);
    };

    const verifyOtp = () => {
        if (verificationMethod === 'Email') {
            const userEmail = getValues('email');
            if (userEmail) {
                setIsLoading(true);
                dispatch(verifyEmailOTP(userEmail, otp.join(''), onOTPVerificationSuccess, onOTPVerificationFailure));
            }
        } else {
            const fullPhone = getValues('phoneNumber') || '';
            const phoneNumber = Number(fullPhone.replace(`${dialCode}`, ''));
            dispatch(verifyPhoneOTP(phoneNumber, Number(dialCode), otp.join(''), onOTPVerificationSuccess, onOTPVerificationFailure));
        }
    };

    const VerifyEmailBody = () => {
        return (
            <div className={styles.accessModalBodyContainer}>
                {
                    <h2 className={styles.successMsg}>
                        {showOTPInput && verificationMethod ? `Verify Your ${verificationMethod}` : `Choose Verification Method`}
                    </h2>
                }
                {(!verificationMethod || !showOTPInput) && (
                    <div className={styles.modalBody}>
                        <RadioInput
                            onChange={(e) => setVerificationMethod(e.target.value as VerificationMethodType)}
                            name="option"
                            value={verificationMethod || ''}
                            options={[
                                { label: 'Verify Using Phone Number', value: 'Phone Number' },
                                { label: 'Verify Using Email', value: 'Email' },
                            ]}
                        />
                        <div className={styles.buttonContainer}>
                            <button
                                className={styles.submitBtn}
                                disabled={!verificationMethod}
                                onClick={() => {
                                    onVerifyEmailPhone();
                                }}>
                                Send OTP
                            </button>
                            <button
                                disabled={isLoading}
                                onClick={() => {
                                    setVerificationMethod(null);
                                    setShowVerifyEmailPopup(false);
                                    setExpiryTimeStamp(null);
                                    setOtp(Array(6).fill(''));
                                }}>
                                Back
                            </button>
                        </div>
                    </div>
                )}
                {verificationMethod && showOTPInput && (
                    <div className={styles.modalBody}>
                        <h6>Enter OTP</h6>
                        <OTPInput otp={otp} setOtp={setOtp} />
                        <p className={styles.email}>
                            <span>We’ve send OTP on </span>
                            <span className={styles.sendBtn}>
                                {verificationMethod === 'Email' ? getValues('email') : `+${getValues('phoneNumber')}`}
                            </span>
                        </p>

                        <div className={styles.inlineItems}>
                            <p className={styles.email}>
                                <span>Didn’t Receive? </span>
                                <button
                                    type="button"
                                    onClick={onVerifyEmailPhone}
                                    className={styles.sendBtn}
                                    disabled={expiryTimeStamp ? true : false}>
                                    Send Again
                                </button>
                            </p>
                            <div>
                                {expiryTimeStamp && (
                                    <Timer expiryTimestamp={expiryTimeStamp.toString()} onExpire={() => setExpiryTimeStamp(null)} />
                                )}
                            </div>
                        </div>

                        <div className={styles.buttonContainer}>
                            <button
                                className={styles.submitBtn}
                                disabled={!otp?.every((value) => value)}
                                onClick={() => verifyOtp()}>{`Verify My ${verificationMethod}`}</button>
                            <button
                                disabled={isLoading}
                                onClick={() => {
                                    setShowVerifyEmailPopup(false);
                                    setExpiryTimeStamp(null);
                                    setOtp(Array(6).fill(''));
                                    setVerificationMethod(null);
                                    setShowOTPInput(false);
                                }}>
                                Back
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const onSuccess = (message: string) => {
        if (message) {
            setToastMessage(message);
            setToastType('success');
            setShowToast(true);
            setShowOTPInput(true);
        }
        setShowVerifyEmailPopup(true);
        setIsLoading(false);
    };

    const onFailure = (message: string) => {
        setToastMessage(message);
        setToastType('error');
        setShowToast(true);
        setIsLoading(false);
    };

    const onVerify = (message: string) => {
        verificationMethod === 'Email' ? setValue('emailVerified', true) : setValue('phoneVerified', true);
        setToastType('success');
        setShowToast(true);
        setIsLoading(false);
        setToastMessage(message);
        setShowOTPInput(false);
        setShowVerifyEmailPopup(false);
        setActiveStep(2);
    };

    const onVerifyEmailPhone = () => {
        if (verificationMethod === 'Email') {
            const userEmail = getValues('email');
            if (userEmail) {
                setIsLoading(true);
                dispatch(sendEmailVerificationRequest(userEmail, setExpiryTimeStamp, onSuccess, onFailure, onVerify));
            }
        } else {
            setIsLoading(true);
            const fullPhone = getValues('phoneNumber') || '';
            const phoneNumber = Number(fullPhone.replace(`${dialCode}`, ''));
            dispatch(sendPhoneVerificationRequest(phoneNumber, Number(dialCode), setExpiryTimeStamp, onSuccess, onFailure, onVerify));
        }
    };

    useEffect(() => {
        if (showToast) {
            setTimeout(() => {
                setShowToast(false);
            }, 4000);
        }
    }, [showToast]);

    const formValues = watch();
    const { firstName, lastName, email, password, confirmPassword } = formValues;

    const handleSaveCardDetail = async (event: React.MouseEvent) => {
        if (!getValues('stripeCustomerId')) {
            event.preventDefault();

            if (!stripe || !elements) {
                return;
            }

            const cardElement: any = elements.getElement(CardElement);

            if (cardElement) {
                setIsLoading(true);
                const response = await stripe.createToken(cardElement);

                if (response?.error) {
                    setIsLoading(false);
                }

                if (response?.token?.card?.funding === 'credit' || response?.token?.card?.funding === 'debit') {
                    setIsLoading(true);
                    const { id } = response.token;
                    if (firstName && lastName && email) {
                        await axios
                            .post('transactions/create-stripe-customer', { token: id, firstName, lastName, email })
                            .then(async (response) => {
                                if (response.status === 201) {
                                    setValue('stripeCustomerId', response.data?.customer_id);
                                    setActiveStep(4);
                                }
                                setIsLoading(false);
                            })
                            .catch((error) => {
                                setToastMessage(error?.response?.data?.message);
                                setShowToast(true);
                                setToastType('error');
                                setIsLoading(false);
                            });
                    } else if (!firstName || !lastName || !email) {
                        setToastMessage(
                            `${!firstName ? 'First Name ' : ''}${!lastName ? 'Last Name ' : ''}${
                                !email ? 'Email ' : ''
                            } Should not be empty.`,
                        );
                        setShowToast(true);
                        setToastType('error');
                        setIsLoading(false);
                    }
                }
            }
        } else {
            setActiveStep(activeStep + 1);
        }
    };

    const updateTCCheck = (status: boolean) => {
        setIsTnCOpen(false);
        setIsChecked(status);
    };

    const onCreateUserSuccess = (data: any) => {
        toast.success('User Created Successfully!');
        appContext.visitorAccessToken = data.token;
        appContext.visitor = data.visitor;
        if (destinationURL && !modifiedAppointment) {
            navigate(destinationURL);
        } else {
            if (modifiedAppointment) {
                navigate(`/appointments${modifiedAppointment || ''}`);
            } else {
                navigate('/appointments');
            }
        }
    };

    const onCreateUserFailure = (message: string) => {
        setShowToast(true);
        setIsLoading(false);
        setToastMessage(message);
        setToastType('error');
    };

    const onSubmit = async (data: any) => {
        try {
            setIsLoading(true);
            let response = '';
            if (preview) {
                const file = base64ToFile(preview as string, 'user', 'image/jpeg');
                response = await uploadImages(file, '/user-profile');
            }
            const fullPhone = data?.phoneNumber;
            const phoneNumber = Number(fullPhone.replace(`${dialCode}`, ''));
            const requestData = {
                photo_url: response,
                firstName: data?.firstName || null,
                lastName: data?.lastName || null,
                fullName: `${data?.firstName || ''} ${data?.lastName || ''}`,
                email: data?.email || null,
                password: data?.password || null,
                stripeDocVerificationClientId: data?.stripeDocVerificationClientId || null,
                stripeCustomerId: data?.stripeCustomerId || null,
                phoneNumber: phoneNumber,
                countryCode: Number(dialCode),
                terms: isChecked || false,
                expectedMoveInDate: data?.expectedMoveInDate ? moment(data?.expectedMoveInDate).format('YYYY-MM-DD') : null,
                desiredNumBedrooms: data?.DesiredBeds || 0,
                leadPropertyLink: locationId ? locationId : '',
                leadUnitLink: unitId ? unitId : '',
                pmsLeadSorce: {
                    lead_PMS: data?.pmsLeadSource?.lead_PMS || '',
                    lead_id: data?.pmsLeadSource?.lead_id || '',
                    lead_name: data?.pmsLeadSource?.lead_name || '',
                },
            };
            dispatch(createUser(requestData, onCreateUserSuccess, onCreateUserFailure));
        } catch (err) {
            console.error('Signup error', err);
        }
    };

    const CustomInput = React.forwardRef<HTMLInputElement, any>((props, ref) => <input {...props} readOnly ref={ref} />);

    const onEmailPhoneValidationFailure = (response: { VerificationType: string; message: string }) => {
        if (response.VerificationType?.toLowerCase() === 'both') {
            setError('email', {
                type: 'already exist',
                message: 'Email already Registered',
            });
            setError('phoneNumber', {
                type: 'already exist',
                message: 'Phone Number already Registered',
            });
            const elements = document.getElementsByClassName('email-input');
            if (elements.length > 0) {
                (elements[0] as HTMLElement).focus(); // Cast to HTMLElement to use `focus`
            }
        } else if (response.VerificationType?.toLowerCase() === 'phone') {
            const elements = document.getElementsByClassName('phone-input');
            if (elements.length > 0) {
                (elements[0] as HTMLElement).focus(); // Cast to HTMLElement to use `focus`
            }
            setError('phoneNumber', {
                type: 'already exist',
                message: 'Phone Number already Registered',
            });
        } else if (response.VerificationType?.toLowerCase() === 'phone-invalid') {
            const elements = document.getElementsByClassName('phone-input');
            if (elements.length > 0) {
                (elements[0] as HTMLElement).focus(); // Cast to HTMLElement to use `focus`
            }
            setError('phoneNumber', {
                type: 'Invalid',
                message: 'Phone Number is Invalid',
            });
        } else {
            const elements = document.getElementsByClassName('email-input');
            if (elements.length > 0) {
                (elements[0] as HTMLElement).focus(); // Cast to HTMLElement to use `focus`
            }
            setError('email', {
                type: 'already exist',
                message: 'Email already Registered',
            });
        }
        setIsLoading(false);
    };

    const onEmailPhoneValidationSuccess = () => {
        setIsLoading(false);
        getValues('emailVerified') || getValues('phoneVerified') ? setActiveStep(activeStep + 1) : setShowVerifyEmailPopup(true);
    };

    const onCheckPhoneEmailExist = () => {
        const fullPhone = getValues('phoneNumber') || '';
        const phoneNumber = Number(fullPhone.replace(`${dialCode}`, ''));
        const verifyUserObj = {
            email: getValues('email'),
            phoneNumber: Number(phoneNumber),
            countryCode: Number(dialCode),
        };
        setIsLoading(true);
        dispatch(checkPhoneEmailExist(verifyUserObj, onEmailPhoneValidationSuccess, onEmailPhoneValidationFailure));
    };

    const onSeenPage = async () => {
        locationId && (await dispatch(locationClickEvent(locationId, 'pageSeen')));
        await navigate('/login', { state: { destinationURL, modifiedAppointment } });
    };

    const redirect = async () => {
        if (contactLink) {
            locationId && (await dispatch(locationClickEvent(locationId, 'selfGuided')));
            window.open(contactLink, '_blank', 'noreferrer');
        }
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0] || null;
        if (file) {
            setValue('profileImage', file, { shouldValidate: true });
            setPreview(URL.createObjectURL(file));
        }
    };

    const requestCameraPermission = async () => {
        const success = await enableCamera();
        if (success) {
            setShowWebCam(true);
        }
    };

    const getPlatform = (): 'android' | 'ios' | 'default' => {
        const userAgentData = (navigator as any).userAgentData;

        // Check modern userAgentData if available
        if (userAgentData?.platform) {
            const platform = userAgentData.platform.toLowerCase();
            if (platform.includes('android')) return 'android';
            if (platform.includes('iphone') || platform.includes('ipad') || platform.includes('ios')) return 'ios';
        }

        // Fallback to userAgent (works for most browsers)
        const userAgent = navigator.userAgent.toLowerCase();
        if (/android/.test(userAgent)) return 'android';
        if (/iphone|ipad|ipod/.test(userAgent)) return 'ios';

        // Additional check for iPadOS, but only if OS is Mac AND browser is Safari (to avoid Ubuntu false positive)
        if (
            navigator.platform === 'MacIntel' &&
            navigator.maxTouchPoints > 1 &&
            /safari/.test(userAgent) &&
            !/chrome|firefox|edg|opr/.test(userAgent) // Ensure it's not Ubuntu
        ) {
            return 'ios';
        }

        return 'default'; // If nothing matches
    };

    const getBrowserName = (): string => {
        const userAgent = navigator.userAgent.toLowerCase();
        const userAgentData = (navigator as any).userAgentData;

        // iOS Browsers
        if (userAgent.includes('crios')) return 'Chrome (iOS)';
        if (userAgent.includes('fxios')) return 'Firefox (iOS)';
        if (userAgent.includes('edgios')) return 'Edge (iOS)';

        // Chromium-based browsers
        if (userAgent.includes('duckduckgo')) return 'DuckDuckGo';
        if (userAgent.includes('vivaldi')) return 'Vivaldi';
        if (userAgent.includes('samsungbrowser')) return 'Samsung Internet';
        if (userAgent.includes('yabrowser')) return 'Yandex Browser';
        if (userAgent.includes('ucbrowser')) return 'UC Browser';

        // More reliable Brave detection
        const isBrave =
            (navigator as any).brave?.isBrave || // Check if Brave explicitly exposes itself
            userAgentData?.brands?.some((brand: { brand: string }) => brand.brand.toLowerCase() === 'brave'); // Check using userAgentData

        if (isBrave) return 'Brave';

        // Standard Browsers
        if (userAgent.includes('opr') || userAgent.includes('opera')) return 'Opera';
        if (userAgent.includes('chrome') && !userAgent.includes('edg') && !userAgent.includes('opr')) return 'Chrome';
        if (userAgent.includes('firefox')) return 'Firefox';
        if (userAgent.includes('safari') && !userAgent.includes('chrome')) return 'Safari';
        if (userAgent.includes('edg')) return 'Edge';
        if (userAgent.includes('trident') || userAgent.includes('msie')) return 'Internet Explorer';

        return 'Unknown';
    };

    const submitPhoto = () => {
        setShowWebCam(false);
    };

    const capturePhoto = () => {
        if (!webcamRef.current) return;

        const imageSrc = webcamRef.current.getScreenshot();
        if (imageSrc) {
            // Convert base64 to Blob
            fetch(imageSrc)
                .then((res) => res.blob())
                .then((blob) => {
                    const file = new File([blob], 'profile.jpg', { type: 'image/jpeg' });
                    setValue('profileImage', file, { shouldValidate: true });
                    setPreview(imageSrc);
                });
        }
    };

    const ModalBody = () => {
        return (
            <div className={styles.modalBodyContainer}>
                <div className={styles.modalHeader}>
                    <h3>Upload Selfie</h3>

                    <div
                        className={styles.closeIcon}
                        onClick={() => {
                            setShowWebCam(false);
                        }}>
                        <img src={CloseIcon} alt="close-icon" width={20} height={20} />
                    </div>
                </div>
                <div className={styles.modalBodyInnerContainer}>
                    {!getValues('profileImage') && (
                        <>
                            <div className={styles.camLayer}>
                                <img src={CamLayer} alt="layer" width={684} height={480} />
                            </div>
                            <Webcam
                                audio={false}
                                className={styles.webCamContainer}
                                screenshotFormat="image/jpeg"
                                videoConstraints={videoConstraints}
                                ref={webcamRef}
                                autoFocus
                            />
                        </>
                    )}

                    {getValues('profileImage') && (
                        <div className={styles.capturedImage}>
                            <img src={URL.createObjectURL(getValues('profileImage') as File)} alt="" width={640} height={480} />
                        </div>
                    )}
                </div>
                <div className={styles.modalFooter}>
                    {getValues('profileImage') && (
                        <button
                            className={styles.retakeBtn}
                            onClick={() => {
                                setValue('profileImage', null);
                                setPreview(null);
                            }}>
                            Recapture Photo
                        </button>
                    )}
                    <button
                        className={getValues('profileImage') ? styles.submitBtn : styles.captureBtn}
                        onClick={getValues('profileImage') ? submitPhoto : capturePhoto}>
                        {!!getValues('profileImage') ? 'Submit my picture' : 'Capture photo'}
                    </button>
                </div>
            </div>
        );
    };

    const CustomModalBody = () => {
        const platform: 'android' | 'ios' | 'default' = getPlatform();
        const browser: string = getBrowserName();

        const instructions: Record<string, { message: string }> = {
            android: {
                message: `To enable camera:\n<span>1️⃣ Open ${browser}.</span><span>2️⃣ Go to Settings > Site Settings.</span><span>3️⃣ Enable camera for this website.</span>`,
            },
            ios: {
                message: `To enable camera:\n<span>1️⃣ Open Settings.</span><span>2️⃣ Go to Privacy & Security > Camera.</span><span>3️⃣ Enable camera for ${browser}.</span>`,
            },
            default: {
                message: 'Please enable camera permissions in your browser settings.',
            },
        };

        const { message } = instructions[platform] || instructions.default;

        return (
            <div className={styles.modalBodyContainer}>
                <div className={`${styles.modalHeader} allowSVG`}>
                    <h3 className={styles.modalH3}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.778 21H14.222C17.343 21 18.904 21 20.025 20.265C20.5088 19.9481 20.9254 19.539 21.251 19.061C22 17.961 22 16.428 22 13.364C22 10.3 22 8.76699 21.251 7.66699C20.9254 7.18898 20.5088 6.77984 20.025 6.46299C19.305 5.98999 18.403 5.82099 17.022 5.76099C16.363 5.76099 15.796 5.27099 15.667 4.63599C15.5684 4.17085 15.3123 3.75402 14.9418 3.45594C14.5714 3.15785 14.1095 2.99679 13.634 2.99999H10.366C9.378 2.99999 8.527 3.68499 8.333 4.63599C8.204 5.27099 7.637 5.76099 6.978 5.76099C5.598 5.82099 4.696 5.99099 3.975 6.46299C3.49154 6.77995 3.07527 7.18907 2.75 7.66699C2 8.76699 2 10.299 2 13.364C2 16.429 2 17.96 2.749 19.061C3.073 19.537 3.489 19.946 3.975 20.265C5.096 21 6.657 21 9.778 21ZM12 9.27299C9.699 9.27299 7.833 11.104 7.833 13.363C7.833 15.622 9.7 17.456 12 17.456C14.3 17.456 16.167 15.624 16.167 13.365C16.167 11.106 14.3 9.27299 12 9.27299ZM12 10.909C10.62 10.909 9.5 12.008 9.5 13.364C9.5 14.719 10.62 15.818 12 15.818C13.38 15.818 14.5 14.719 14.5 13.364C14.5 12.009 13.38 10.909 12 10.909ZM16.722 10.091C16.722 9.63899 17.095 9.27299 17.556 9.27299H18.666C19.126 9.27299 19.5 9.63899 19.5 10.091C19.4979 10.3099 19.409 10.519 19.2528 10.6724C19.0966 10.8257 18.8859 10.9109 18.667 10.909H17.556C17.4475 10.91 17.3399 10.8897 17.2393 10.8492C17.1387 10.8086 17.047 10.7487 16.9696 10.6727C16.8921 10.5968 16.8304 10.5063 16.7879 10.4065C16.7454 10.3067 16.723 10.1995 16.722 10.091Z"
                                fill="black"
                            />
                        </svg>
                        <span>Enable Camera Access</span>
                    </h3>
                </div>
                <div className={styles.modalBodyInnerContainer}>
                    <p className={styles.preWrappedMessage} dangerouslySetInnerHTML={{ __html: message }}></p>
                </div>

                <div className={styles.modalFooter}>
                    <button className={styles.captureBtn} onClick={() => setShowCustomModal(false)}>
                        Okay
                    </button>
                </div>
            </div>
        );
    };

    return (
        <>
            {(isLoading || webhookWaiting) && <Loader />}
            <div
                className={`${styles.signupContainer}  ${
                    locationData && locationData?.data && locationData?.data?.images?.length ? styles.propertyImageWrapper : ''
                }`}
                style={
                    locationData?.data?.images?.[0]
                        ? {
                              backgroundImage: `url(${locationData?.data.images[0]})`,
                              backgroundRepeat: 'no-repeat',
                              backgroundSize: 'cover',
                              backgroundPosition: 'center',
                              backgroundAttachment: 'fixed',
                              width: '100%',
                          }
                        : {}
                }>
                {/* {(locationData && locationData?.images && locationData?.images?.length && locationId) && <div className={styles.propertyImageWrapper}>
        <img src={locationData?.images[0]} alt='property image' width={100} height={100} />
      </div>} */}
                <div className={styles.innerContainer}>
                    <form
                        className={`${styles.formWrapper} ${locationData?.data?.images?.length ? styles.marketingLink : ''}`}
                        onSubmit={activeStep === 4 ? handleSubmit(onSubmit) : (e) => e.preventDefault()}>
                        <div className={styles.tabWrapper}>
                            {activeStep <= 4 &&
                                Array.from({ length: 4 }).map((_value, index) => {
                                    return (
                                        <div
                                            className={`${styles.tab} ${
                                                activeStep === index + 1 ? styles.active : activeStep > index + 1 ? styles.completed : ''
                                            }`}></div>
                                    );
                                })}
                        </div>
                        <div className={styles.stepHeader}>
                            {activeStep !== 4 && <h6>{`STEP ${activeStep}`}</h6>}
                            <h2>
                                {activeStep === 1
                                    ? 'Tell us about yourself'
                                    : activeStep === 2
                                    ? 'Verify documents with Stripe'
                                    : activeStep === 3
                                    ? 'Verify credit card details'
                                    : activeStep === 4
                                    ? 'Set your credentials'
                                    : ''}
                            </h2>
                        </div>
                        {activeStep === 1 && (
                            <div className={styles.formStep1}>
                                <Controller
                                    name="firstName"
                                    control={control}
                                    rules={{
                                        required: 'First Name is required',
                                    }}
                                    render={({ field: { onChange, value } }) => {
                                        return (
                                            <TextInput
                                                label="First Name"
                                                placeHolder="First Name"
                                                onChange={onChange}
                                                value={value}
                                                error={errors?.firstName?.message || ''}
                                            />
                                        );
                                    }}
                                />

                                <Controller
                                    name="lastName"
                                    control={control}
                                    rules={{
                                        required: 'Last Name is required',
                                    }}
                                    render={({ field: { onChange, value } }) => {
                                        return (
                                            <TextInput
                                                label="Last Name"
                                                placeHolder="Last Name"
                                                onChange={onChange}
                                                value={value}
                                                error={errors?.lastName?.message || ''}
                                            />
                                        );
                                    }}
                                />

                                <Controller
                                    name="email"
                                    control={control}
                                    rules={{
                                        required: 'Email Address is required',
                                        pattern: {
                                            value: REGEX.EMAIL,
                                            message: 'Enter Valid Email Address',
                                        },
                                    }}
                                    render={({ field: { onChange, value } }) => {
                                        return (
                                            <EmailInput
                                                label="Email"
                                                className="email-input"
                                                placeHolder="Enter Email Address"
                                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                    onChange(event.target.value?.toString().toLowerCase());
                                                    if (getValues('emailVerified') || verificationMethod === 'Email') {
                                                        setValue('emailVerified', false);
                                                    }
                                                }}
                                                value={value}
                                                error={errors?.email?.message || ''}
                                            />
                                        );
                                    }}
                                />

                                <Controller
                                    name="phoneNumber"
                                    control={control}
                                    rules={{
                                        required: 'Phone number should not be empty',
                                    }}
                                    render={({ field: { onChange, value } }) => {
                                        return (
                                            <div className={`${styles.fieldWrapper} ${styles.sm} ${styles.phoneNum}`}>
                                                <label>Phone Number</label>
                                                <PhoneInput
                                                    country={'us'}
                                                    value={value}
                                                    inputClass="phone-input"
                                                    onChange={(value: string, data: CountryData) => {
                                                        if (verificationMethod === 'Phone Number' || getValues('phoneVerified')) {
                                                            setValue('phoneVerified', false);
                                                        }
                                                        setPhoneNumberLength(data?.format?.length);
                                                        onChange(value);
                                                        setDialCode(data?.dialCode);
                                                    }}
                                                    inputStyle={{
                                                        marginLeft: '30px',
                                                        maxWidth: 'calc(100% - 30px)',
                                                    }}
                                                    inputProps={{
                                                        required: true,
                                                        maxLength: phoneNumberLength,
                                                    }}
                                                    enableSearch
                                                    disableCountryGuess
                                                    copyNumbersOnly
                                                    countryCodeEditable={false}
                                                    enableLongNumbers={true}
                                                />
                                                {errors?.phoneNumber && <p className={styles.errorText}>{errors?.phoneNumber?.message}</p>}
                                            </div>
                                        );
                                    }}
                                />

                                <Controller
                                    name="expectedMoveInDate"
                                    control={control}
                                    rules={{
                                        required: 'Move in date should not be empty',
                                        validate: (value) => {
                                            if (!value) return 'Move in date should not be empty';
                                            const selectedDate = moment(value, 'MM DD YYYY');
                                            if (selectedDate.isSameOrAfter(moment(), 'day')) {
                                                return true;
                                            }
                                            return 'Move in date should be today or later';
                                        },
                                    }}
                                    render={({ field: { onChange, value } }) => {
                                        return (
                                            <div className={styles.fieldWrapper}>
                                                <label>Expected Move In Date</label>
                                                <DatePicker
                                                    selected={value ? moment(value, 'MM DD YYYY').toDate() : null}
                                                    onChange={(date: Date | null) => {
                                                        const formattedDate = date ? moment(date).format('MM/DD/YYYY') : '';
                                                        onChange(formattedDate);
                                                    }}
                                                    popperPlacement="top"
                                                    dateFormat="MM/dd/yyyy"
                                                    minDate={new Date()}
                                                    placeholderText="MM/DD/YYYY"
                                                    customInput={<CustomInput />}
                                                />
                                                {errors?.expectedMoveInDate && (
                                                    <p className={styles.errorText}>{errors?.expectedMoveInDate?.message}</p>
                                                )}
                                            </div>
                                        );
                                    }}
                                />

                                <Controller
                                    name="DesiredBeds"
                                    control={control}
                                    rules={{
                                        required: 'Last Name is required',
                                    }}
                                    render={({ field: { onChange, value } }) => {
                                        return (
                                            <div className={`${styles.fieldWrapper} ${styles.dropDownOption}`}>
                                                <label>Desired Number of Bedrooms</label>
                                                <div className="profile-custom-dropdown">
                                                    <Select
                                                        onChange={(selectedOption: SingleValue<OptionType>) =>
                                                            onChange(selectedOption ? selectedOption.value : null)
                                                        }
                                                        classNamePrefix="custom-profile-dropdown"
                                                        options={
                                                            locationData?.maxRoom !== null && locationData?.maxRoom !== undefined
                                                                ? generateBedArray(Number(locationData?.maxRoom))
                                                                : bed
                                                        }
                                                        menuPosition="absolute"
                                                        menuPlacement="top"
                                                        isMulti={false}
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            menuPortal: (base) => ({ ...base, zIndex: 9, fontSize: 14, fontWeight: 400 }),
                                                            menuList: (base) => ({
                                                                ...base,
                                                                maxHeight: '124px',
                                                                height: '100%',
                                                            }),
                                                            option: (base) => ({ ...base, cursor: 'pointer' }),
                                                        }}
                                                        placeholder={<div className="selectPlaceholderText">Select</div>}
                                                        value={bed.find((option) => option.value === value) || null}
                                                    />
                                                    <span className="custom-dropdown-indicator">
                                                        <img src={drop} alt="dropdown icon" />
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    }}
                                />

                                {(!destinationURL || destinationURL === '/') && (
                                    <div className={`${styles.fieldWrapper} ${styles.dropDownOption}`}>
                                        <label>Which community are you interested in touring?</label>
                                        <div className="profile-custom-dropdown">
                                            <Select
                                                onChange={(selectedOption: SingleValue<OptionType>) => {
                                                    if (selectedOption && selectedOption?.value && locationId !== selectedOption?.value) {
                                                        setLocationId(selectedOption?.value);
                                                    } else {
                                                        setValue('pmsLeadSource', null);
                                                        setLocationId(null);
                                                    }
                                                }}
                                                classNamePrefix="custom-profile-dropdown"
                                                options={locationListData?.map(({ id, name }: { id: string; name: string }) => {
                                                    return { label: name, value: id };
                                                })}
                                                menuPosition="absolute"
                                                menuPlacement="top"
                                                isMulti={false}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9, fontSize: 14, fontWeight: 400 }),
                                                    menuList: (base) => ({
                                                        ...base,
                                                        maxHeight: '124px',
                                                        height: '100%',
                                                    }),
                                                    option: (base) => ({ ...base, cursor: 'pointer' }),
                                                }}
                                                placeholder={<div className="selectPlaceholderText">Select</div>}
                                                value={(() => {
                                                    const selectedValue = locationId
                                                        ? locationListData?.find(({ id }: { id: string }) => id === locationId) || null
                                                        : null;
                                                    return selectedValue ? { label: selectedValue?.name, value: selectedValue?.id } : null;
                                                })()}
                                            />
                                            <span className="custom-dropdown-indicator">
                                                <img src={drop} alt="dropdown icon" />
                                            </span>
                                        </div>
                                    </div>
                                )}

                                {locationId !== '' && !!leadSource?.length && (
                                    <div
                                        className={`${styles.fieldWrapper} ${styles.dropDownOption} ${styles.md} guestCardDropdown`}
                                        style={{ width: '100%' }}>
                                        <label>How did you hear about us?</label>
                                        <Controller
                                            name="pmsLeadSource"
                                            control={control}
                                            render={({ field }) => {
                                                const selectedOption = leadSource?.find(
                                                    (source: LeadSourceOption) => source?.lead_name === field.value?.lead_name,
                                                );

                                                return (
                                                    <Select
                                                        {...field}
                                                        options={leadSource?.map((source: LeadSourceOption) => ({
                                                            value: source.lead_name,
                                                            label: source.lead_name,
                                                            lead_id: source.lead_id,
                                                            lead_name: source.lead_name,
                                                            lead_PMS: source.lead_PMS,
                                                        }))}
                                                        getOptionLabel={(e) => e.label}
                                                        getOptionValue={(e) => e.value}
                                                        menuPortalTarget={document.body}
                                                        menuPlacement="top"
                                                        styles={{
                                                            menuPortal: (base) => ({
                                                                ...base,
                                                                zIndex: 9999,
                                                                fontSize: 14,
                                                                fontWeight: 400,
                                                            }),
                                                        }}
                                                        placeholder={<div className="selectPlaceholderText">Select</div>}
                                                        value={field.value ? field?.value : null}
                                                        onChange={(selectedOption) => {
                                                            field.onChange(selectedOption);
                                                        }}
                                                    />
                                                );
                                            }}
                                        />

                                        <span className={styles.dropDownIcon}>
                                            <img src={drop} alt="dropdown icon" />
                                        </span>
                                    </div>
                                )}
                            </div>
                        )}

                        {activeStep === 2 && (
                            <div className={styles.stripeVerificationImg}>
                                <img src={StripeVerification} alt="stripe verification" width={392} height={287} />
                            </div>
                        )}

                        {activeStep === 3 && (
                            <Suspense fallback={<Loader />}>
                                <div className={`${styles.formStep1} creditCard`}>
                                    <div className={styles.chargeInfo}>
                                        <h3 className={styles.title}>Liability Preauthorization</h3>
                                        <p className={styles.description}>
                                            {' '}
                                            As with any hotel stay, your credit card will cover the of incidence of damages resulting from
                                            your tour or keys not being returned.
                                        </p>
                                    </div>
                                    {!!getValues('stripeCustomerId') ? (
                                        <div className={styles.inlineItems}>
                                            <h2 style={{ fontWeight: '500' }}>Card Details Verified Successfully.</h2>
                                        </div>
                                    ) : (
                                        <div>
                                            <CardElement onChange={handleCardChange} />
                                            {cardError && <p className={styles.errorText}>{cardError}</p>}
                                        </div>
                                    )}

                                    <div className={`${styles.customBoxes} ${styles.boxes}`}>
                                        <input type="checkbox" id="terms" name="terms" checked={isChecked} />
                                        <label onClick={() => setIsTnCOpen(true)}>Accept Terms and Conditions</label>
                                    </div>
                                </div>
                            </Suspense>
                        )}

                        {activeStep === 4 && (
                            <Suspense fallback={<Loader />}>
                                <div className={`${styles.formStep1} `}>
                                    <Controller
                                        name="password"
                                        control={control}
                                        rules={{
                                            required: 'Password is required',
                                            pattern: {
                                                value: REGEX.PASSWORD,
                                                message:
                                                    'The password must contain at least one character, one number, one special character, and be between 8 and 12 characters in length',
                                            },
                                        }}
                                        render={({ field: { onChange, value } }) => {
                                            return (
                                                <PasswordInput
                                                    label="Password"
                                                    value={value}
                                                    onChange={(e) => {
                                                        onChange(e);
                                                        getValues('confirmPassword') !== '' && trigger('confirmPassword');
                                                    }}
                                                    error={errors?.password?.message || ''}
                                                    key={'password'}
                                                    name="password"
                                                    id="new password"
                                                    placeHolder="Set My Password"
                                                />
                                            );
                                        }}
                                    />

                                    <Controller
                                        name="confirmPassword"
                                        control={control}
                                        rules={{
                                            required: 'Confirm password is required',
                                            validate: (value) => value == getValues('password') || 'The passwords do not match',
                                        }}
                                        render={({ field: { value } }) => {
                                            return (
                                                <PasswordInput
                                                    label="Confirm Password"
                                                    value={value}
                                                    onChange={(e) => {
                                                        setValue('confirmPassword', e.target.value, {
                                                            shouldValidate: getValues('password') !== '' ? true : false,
                                                        });
                                                    }}
                                                    error={errors?.confirmPassword?.message || ''}
                                                    key={'confirmPassword'}
                                                    name="confirmPassword"
                                                    placeHolder="Confirm Password"
                                                />
                                            );
                                        }}
                                    />
                                </div>
                            </Suspense>
                        )}

                        {activeStep === 1 && (
                            <div className={styles.actionBtnContainer}>
                                <button
                                    type="button"
                                    onClick={() => {
                                        onCheckPhoneEmailExist();
                                    }}
                                    className={styles.btnGreen}
                                    disabled={
                                        !(
                                            !!getValues('DesiredBeds') &&
                                            !!getValues('email') &&
                                            !!getValues('expectedMoveInDate') &&
                                            getValues('firstName') &&
                                            !!getValues('lastName') &&
                                            !!getValues('phoneNumber') &&
                                            checkIsValid()
                                        )
                                    }>
                                    Next
                                </button>

                                <div className={styles.linkBtnContainer}>
                                    <button type="button" className={styles.linkBtn} onClick={onSeenPage}>
                                        Seen this page before? Sign In to your account
                                    </button>
                                    <button
                                        type="button"
                                        className={styles.linkBtn}
                                        onClick={redirect}>{`Not looking for a self-guided tour?\nContact the property`}</button>
                                </div>
                            </div>
                        )}

                        {activeStep === 2 && (
                            <div className={styles.actionBtnContainer}>
                                {!getValues('stripeDocVerificationClientId') ? (
                                    <button type="button" onClick={verifyId} className={styles.btnGreen}>
                                        Verify
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        onClick={() => setActiveStep(3)}
                                        className={styles.btnGreen}
                                        disabled={!getValues('stripeDocVerificationClientId')}>
                                        Next
                                    </button>
                                )}

                                <button type="button" onClick={() => setActiveStep(activeStep - 1)} className={styles.backBtn}>
                                    Back
                                </button>
                            </div>
                        )}

                        {activeStep === 3 && (
                            <div className={styles.actionBtnContainer}>
                                <button
                                    type="button"
                                    onClick={(e: React.MouseEvent) => {
                                        e.preventDefault();
                                        handleSaveCardDetail(e);
                                    }}
                                    className={styles.btnGreen}
                                    disabled={
                                        !!getValues('stripeCustomerId') && isChecked ? false : !(cardComplete && !cardError && isChecked)
                                    }>
                                    Finish Account Setup
                                </button>

                                <button type="button" onClick={() => setActiveStep(activeStep - 1)} className={styles.backBtn}>
                                    Back
                                </button>
                            </div>
                        )}

                        {activeStep === 4 && (
                            <div className={styles.actionBtnContainer}>
                                <button
                                    type="submit"
                                    className={styles.btnGreen}
                                    disabled={
                                        !(
                                            password &&
                                            confirmPassword &&
                                            password === confirmPassword &&
                                            !errors.password &&
                                            !errors.confirmPassword
                                        )
                                    }>
                                    Set My Password
                                </button>

                                <button type="button" onClick={() => setActiveStep(activeStep - 1)} className={styles.backBtn}>
                                    Back
                                </button>
                            </div>
                        )}
                    </form>
                </div>

                {!!showVerifyEmailPopup && (
                    <Popup
                        open={showVerifyEmailPopup}
                        setOpen={setShowVerifyEmailPopup}
                        onCloseModal={() => {
                            setShowVerifyEmailPopup(false);
                            setExpiryTimeStamp(null);
                            setOtp(Array(6).fill(''));
                            if (getValues('emailVerified')) {
                                setValue('emailVerified', false);
                            }
                        }}
                        bodyData={<VerifyEmailBody />}
                        className="custom-webcam-modal otp-modal"
                        shouldCloseOnOverlayClick={false}
                    />
                )}

                {showToast && toastType && toastMessage && <Toast message={toastMessage} type={toastType} />}

                <Popup
                    className="custom-webcam-modal "
                    open={isOpen}
                    setOpen={setIsTnCOpen}
                    bodyData={<Terms setOpen={setIsTnCOpen} handleBtnClick={updateTCCheck} />}
                />
                <Popup open={showWebCam} setOpen={setShowWebCam} bodyData={<ModalBody />} />
                {showCustomModal && (
                    <Popup
                        setOpen={setShowCustomModal}
                        className="custom-webcam-modal"
                        open={showCustomModal}
                        bodyData={<CustomModalBody />}
                    />
                )}
            </div>
        </>
    );
};

export default SignUp;
